/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import Flickity from "flickity";
import Cookies from 'js-cookie'

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** Toggle menu */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      let timerMenu = 0;
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          HTML.classList.toggle("open-menu");

          if (!HTML.classList.contains("open-menu")) {
            timerMenu = setTimeout(() => {
              window.dispatchEvent(new Event("reinit-menu"));
            }, 500);
          } else {
            const els = document.querySelectorAll('.popin-game.show');
            HTML.classList.remove("open-popin");
            HTML.classList.remove("open-search");
            
            if( els ) els.forEach(el => el.classList.remove('show'))

            clearTimeout(timerMenu);
          }
        });
      });
    }

    window.addEventListener('click', (e) => {
      if( HTML.classList.contains("open-menu") && !e.target.closest('.main-nav') && !e.target.classList.contains('main-nav')) {
        HTML.classList.remove('open-menu')
      }
    })

    /** Toggle search */
    const searchToggles = document.querySelectorAll('a[href*="#search"]');
    if (searchToggles) {
      searchToggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-search");

          if (HTML.classList.contains("open-search")) {
            HTML.classList.remove("open-menu");
          }
        });
      });
    }

    window.addEventListener("load", () => {
      this.menu();
    });

    this.cookie();
    this.videoPlayer();
    this.textareaResize();
    this.carousel();
    this.accordion();
    this.events();
    this.gameDragons();
    this.inViewport();
  }
  
  cookie() {

    /** Cookie */
    tarteaucitron.init({
      "privacyUrl": "",                /* Privacy policy url . Si vide, le lien Politique de confidencialité du bandeau ne s'affiche pas*/
      "hashtag": "#consentement",      /* La gestionnaire de consentement s'ouvre avec ce hashtag lorsqu'il est placé dans l'url */
      "cookieName": "tarteaucitron",   /* L'identifiant du cookie déposé sur le poste utilisateur */
      "bodyPosition": "top",           /* Position à laquelle le gestionnaire - niveau 2 -  est inséré dans la page (top ou bottom). Pour que les technologies d'assistance puisse y acceder rapidement à la navigation, 'top' est la valeur privilégiée. */
      "adblocker": false,              /* Show a Warning if an adblocker is detected */
      "highPrivacy": true,             /* Retire le consentement implicite (au scroll ou à la navigation) Activé par défaut, donc on peut le retirer de cette config */
      "handleBrowserDNTRequest": false,/* Active ou désactive la prise en compte du Do Not track Navigateur. Si le DNT est activé, aucun cookie n'est déposé */
      "useExternalCss": true,         /* Active ou non une css custom - désactive ou non la css par défaut */
      
      /* Bandeau d'information cookies (niveau 1)*/
      "orientation": "bottom",/* Position de la bannière de niveau 1 (middle - top - bottom). Si la position est middle, il y a un overlay derrière donc laisser à top ou bottom. */
      "DenyAllCta" : true,    /* Affiche le bouton 'Tout refuser' sur le bandeau de niveau 1 */
      "AcceptAllCta" : true,  /* Affiche le bouton 'Tout accepter' sur le bandeau de niveau 1 */
      "closePopup": false,    /* ajoute une croix de fermeture */

      /* Gestionnaire de cookies (niveau 2) */
      "removeCredit": true, /* Affiche ou non les credit TAC */
      "moreInfoLink": false,/*  Affiche ou non le liens vers les infos*/
      "readmoreLink": true,/* Change the default readmore link pointing to tarteaucitron.io */
      "mandatory": true,    /* Message à propos des cookies dits fonctionnels  */


      /* Sticky d'ouverture niveau 2 */
      /* Blocs 'Gestion des cookies' */
      "showAlertSmall": false, /* 'bouton' sticky (en bas a droite) permettant d'ouvrir le gestionnaire de niveau 2*/
      "cookieslist": false,   /* Ajoute le nombre de services au 'block' sticky */
      /* Icone sticky */
      "showIcon": true,             /* affichage du Bouton sticky (icone citron) pour ouvrir le gestionnaire */
      "iconPosition": "BottomLeft", /* Position du Bouton sticky BottomRight, BottomLeft, TopRight and TopLeft */
      "groupServices": false
    });

    (tarteaucitron.job = tarteaucitron.job || []).push('youtube');

    tarteaucitron.user.matomotmUrl = "https://piwik.prod.metzcomm-prod1.emisfr.net/";
    (tarteaucitron.job = tarteaucitron.job || []).push('matomotm')

    tarteaucitron.user.matomoId = 61;
    tarteaucitron.user.matomoHost = 'https://piwik.prod.metzcomm-prod1.emisfr.net/';
    (tarteaucitron.job = tarteaucitron.job || []).push('matomohightrack');

    const btn = document.querySelector('.cookie-btn');
    if( btn ) {
      btn.addEventListener('click', e => {
        e.preventDefault();
        tarteaucitron.userInterface.openPanel();
      })
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  menu() {
    const menu = document.querySelector(".primary-menu");

    if (menu) {
      const triggers = menu.querySelectorAll(".menu-item-has-children > a");
      const links = menu.querySelectorAll("& > li > a");

      if (triggers) {
        triggers.forEach((trigger) => {
          const li = trigger.closest("li");
          const submenuLinks = li.querySelectorAll(".sub-menu > li");
          const submenu = li.querySelector(".sub-menu");
          const tl = gsap.timeline({ paused: true });

          tl.to(
            links,
            {
              x: "-50%",
              autoAlpha: 0,
              stagger: 0.03,
              duration: 0.4,
              ease: "circ.in",
            },
            "start"
          )
            .to(submenu, {
              pointerEvents: "auto",
            })
            .to(
              menu,
              {
                duration: 0.5,
                ease: "power2.inOut",
                height: submenu.offsetHeight,
              },
              "start+=0.3"
            )
            .to(
              submenuLinks,
              {
                x: "0%",
                duration: 0.3,
                stagger: 0.03,
                autoAlpha: 1,
                pointerEvents: "auto",
              },
              "-=0.5"
            );

          li.timeline = tl;

          trigger.addEventListener("click", (e) => {
            e.preventDefault();

            li.timeline.play();
          });
        });

        window.addEventListener("reinit-menu", () => {
          triggers.forEach((trigger) => {
            if (trigger.timeline) trigger.timeline.seek(0).pause();
          });
        });
      }

      const btnsBack = menu.querySelectorAll(".btn-back");
      if (btnsBack) {
        btnsBack.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const parent = btn.closest(".menu-item-has-children");

            if (parent && parent.timeline) {
              parent.timeline.reverse();
            }
          });
        });
      }
    }
  }

  videoPlayer() {
    const players = document.querySelectorAll(".player-js");

    if (players) {
      players.forEach((player) => {
        const video = player.querySelector("video:not(.preview)");
        let stopAutoplay = false;

        if (video) {
          /** BUILD CONTROLS */
          const controls = document.createElement("div");
          controls.classList.add("controls");
          player.append(controls);

          const playPause = document.createElement("a");
          playPause.classList.add("play-pause");
          controls.append(playPause);

          const progress = document.createElement("div");
          progress.classList.add("progress");
          controls.append(progress);
          const bar = document.createElement("div");
          bar.classList.add("bar");
          progress.append(bar);

          const sound = document.createElement("a");
          sound.classList.add("sound");
          controls.append(sound);

          const fullscreen = document.createElement("a");
          fullscreen.classList.add("fullscreen");
          controls.append(fullscreen);

          const btnPlay = player.querySelector("[data-play]");
          if (btnPlay) {
            btnPlay.addEventListener("click", (e) => {
              e.preventDefault();
              video.dispatchEvent(new Event('click'))
            });
          }
          const trigger = player.querySelector("[data-trigger-player]");
          if (trigger) {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              video.dispatchEvent(new Event('click'))
            });
          }

          /** EVENTS LISTENER */
          // CLICK
          playPause.addEventListener("click", (e) => {
            e.preventDefault();
            video.dispatchEvent(new Event('click'))
          });

          // PROGRESS CLICK
          progress.addEventListener("click", (e) => {
            const bounding = progress.getBoundingClientRect();
            const percent = (e.clientX - bounding.x) / bounding.width;

            video.currentTime = percent * video.duration;
          });

          // CLICK
          video.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if( video.dataset.autoplay && !stopAutoplay ) {
              video.dataset.autoplay = false
              stopAutoplay = true;
              video.muted = false;
              video.loop = false;
              player.classList.add("is-playing");
            }
            else {
              if (video.paused) video.play();
              else video.pause();
            }

          });

          // FULLSCREEN
          fullscreen.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.fullscreenElement) {
              video.requestFullscreen();
            } else if (video.exitFullscreen) {
              video.exitFullscreen();
            }
          });

          // SOUND
          sound.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.muted) {
              video.muted = true;
              player.classList.add("soundoff");
            } else {
              video.muted = false;
              player.classList.remove("soundoff");
            }
          });

          video.addEventListener("mouseenter", () => {
            player.classList.add("is-mouseenter");
          });
          video.addEventListener("mouseleave", () => {
            player.classList.remove("is-mouseenter");
          });

          // IS PLAYING
          video.addEventListener("playing", () => {
            if( stopAutoplay )
              player.classList.add("is-playing");
          });
          // IS PAUSE
          video.addEventListener("pause", () => {
            player.classList.remove("is-playing");
          });

          // TIMEUPDATE
          video.addEventListener("timeupdate", () => {
            gsap.set(bar, {
              width: `${(video.currentTime / video.duration) * 100}%`,
            });
          });
        }
      });
    }
  }

  carousel() {
    const carousels = document.querySelectorAll(".carousel");

    if (carousels) {
      carousels.forEach((carousel) => {
        new Flickity(carousel, {
          pageDots: false,
          contain: true,
          cellAlign: "left",
          on: {
            select(index) {
              const w = this.size.width;
              const wCell = this.cells[0].element.offsetWidth;
              const nbVisibleCells = Math.round(w / wCell);

              if (index == 0) this.prevButton.element.classList.add("disabled");
              else this.prevButton.element.classList.remove("disabled");

              if (index + nbVisibleCells >= this.cells.length)
                this.nextButton.element.classList.add("disabled");
              else this.nextButton.element.classList.remove("disabled");
            },
          },
        });
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((accordion) => {
        const triggers = accordion.querySelectorAll(".accordion-header");
        const contents = accordion.querySelectorAll(".accordion-content");

        if (triggers && contents) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              const parent = trigger.closest(".accordion-item");
              parent.classList.toggle("active");

              if (contents[i]) {
                const child = contents[i].children[0];

                trigger.ariaExpanded = !!parent.classList.contains("active");

                gsap.to(contents[i], {
                  duration: 0.4,
                  ease: "circ.inOut",
                  height: parent.classList.contains("active")
                    ? child.offsetHeight
                    : 0,
                });
                gsap.to(child, {
                  duration: 0.4,
                  autoAlpha: parent.classList.contains("active") ? 1 : 0,
                  delay: parent.classList.contains("active") ? 0.2 : 0,
                });
              }
            });
          });
        }
      });
    }
  }

  events() {
    const elts = document.querySelectorAll('.events-container');

    if( elts ) {
      elts.forEach(el => {
        const calendar = el.querySelector('.calendar');
        const listing = el.querySelector('.listing');
        let current = -1;

        if( calendar && listing ) {
          const eventsCalendar = calendar.querySelectorAll('.events-calendar');
          const eventsListing = listing.querySelectorAll('.events-listing');
          const calendarTriggers = calendar.querySelectorAll('[data-events]');

          // Calendar navigation
          if( eventsCalendar && eventsListing ) {
            function goto(next) {
              let delay = 0.1;
              if( current >= 0 ) {
                gsap.to(eventsCalendar[current], {
                  autoAlpha: 0,
                  ease: 'power3.inOut',
                  x : `${current > next ? 100 : -100}%`
                })

                gsap.to(eventsListing[current], {
                  autoAlpha: 0,
                  ease: 'power1.inOut',
                  y : `${current > next ? 2 : -2}rem`
                })
                delay = 0.2
              }

              gsap.to(eventsCalendar[next], {
                autoAlpha: 1,
                x : '0%',
                ease: 'power3.inOut'
              })
              gsap.to(eventsListing[next], {
                autoAlpha: 1,
                y : '0rem',
                delay,
                duration: 0.3,
                ease: 'power3.inOut'
              })

              current = next;
              window.dispatchEvent(new Event('resize'));
            }

            window.addEventListener('resize', () => {

              const heightCalendar = eventsCalendar[current].offsetHeight;
              gsap.to(calendar, {
                height : heightCalendar,
                ease: 'power3.inOut',
              })

              const heightListing = eventsListing[current].offsetHeight;
              gsap.to(listing, {
                height : heightListing,
                ease: 'power3.inOut',
                onComplete : () => {
                  // window.dispatchEvent(new Event('reinit-filter'));
                }
              })
            })

            // Nav
            const navs = calendar.querySelectorAll('.nav-calendar a');
            if( navs ) {
              navs.forEach(trigger => {
                trigger.addEventListener('click', e => {
                  e.preventDefault();

                  const dir = trigger.classList.contains('previous') ? -1 : 1;
                  const index = parseInt(trigger.dataset.index);

                  goto(index+dir);
                })
              })
            }

            goto(0);
          }

          // Click on event
          if( calendarTriggers) {
            let currentTrigger = -1;

            calendarTriggers.forEach((trigger, i) => {
              trigger.addEventListener('click', e => {
                e.preventDefault();
                const ids = trigger.dataset.events.split('|');

                if( currentTrigger >= 0 && currentTrigger != i) {
                  calendarTriggers[currentTrigger].classList.remove('active')
                }

                trigger.classList.toggle('active')
                currentTrigger = i;
                
                const events = eventsListing[current].querySelectorAll('.event');

                if( events ) {
                  events.forEach(e => {
                    if( !ids.includes(e.dataset.id) && trigger.classList.contains('active') ) {
                      gsap.to(e, {
                        height: '0px',
                        duration: 0.3,
                        ease: 'power4.inOut'
                      })
                    } else {
                      gsap.to(e, {
                        height: `${e.children[0].offsetHeight}px`,
                        ease: 'power4.inOut',
                        duration: 0.3,
                        onComplete : () => {
                          gsap.set(e, { clearProps : 'all'})
                        }
                      })
                    }
                  })

                  setTimeout(() => { 
                    
                    const heightListing = eventsListing[current].offsetHeight;
                    gsap.to(listing, {
                      height : heightListing,
                      ease: 'power3.inOut'
                    })
                   }, 300)
                }
              })
            })

            window.addEventListener('reinit-filter', () => {
              calendarTriggers.forEach(trigger => { trigger.classList.remove('active')})
              listing.querySelectorAll('.event').forEach(e => {
                gsap.set(e, { clearProps : 'all'})
              })
            })
          }

        }
      })
    }

    /** Button add to agenda */
    const btns = document.querySelectorAll('.trigger-perso-agenda')
    if( btns ) {
      btns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();

          // Format dates
          const dates = JSON.parse(btn.dataset.dates);
          let icsDates = '';
          for(const i in dates){
            const date = dates[i];
            const start = date.start.replaceAll('-', '').replaceAll(' ', 'T').replaceAll(':', '');
            const end = date.end.replaceAll('-', '').replaceAll(' ', 'T').replaceAll(':', '');
            icsDates += 'BEGIN:VEVENT\r\n';
            icsDates += 'UID:'+start+'+contact@metzletudiante.fr'+'\r\n';
            icsDates += 'DTSTAMP:'+start+'\r\n';
            icsDates += 'DTSTART;TZID=Europe/Paris:'+start+'\r\n';
            icsDates += 'DTEND;TZID=Europe/Paris:'+end+'\r\n';
            icsDates += 'SUMMARY:' + btn.dataset.title +'\r\n';
            icsDates += 'LOCATION:' + btn.dataset.location +'\r\n';
            icsDates += 'END:VEVENT\r\n';
          }

          // Format: https://docs.fileformat.com/email/ics/
          let icsMSG = '';
          icsMSG = 'BEGIN:VCALENDAR\n';
          icsMSG += 'VERSION:2.0\r\n';
          icsMSG += "PRODID:-//Our Company//NONSGML v1.0//EN\r\n";
          icsMSG += 'BEGIN:VTIMEZONE\r\n';
          icsMSG += 'TZID:Europe/Paris\r\n';
          icsMSG += 'BEGIN:DAYLIGHT\r\n';
          icsMSG += 'TZOFFSETFROM:+0100\r\n';
          icsMSG += 'TZOFFSETTO:+0200\r\n';
          icsMSG += 'TZNAME:CEST\r\n';
          icsMSG += 'DTSTART:19700329T020000\r\n';
          icsMSG += 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r\n';
          icsMSG += 'END:DAYLIGHT\r\n';
          icsMSG += 'BEGIN:STANDARD\r\n';
          icsMSG += 'TZOFFSETFROM:+0200\r\n';
          icsMSG += 'TZOFFSETTO:+0100\r\n';
          icsMSG += 'TZNAME:CET\r\n';
          icsMSG += 'DTSTART:19701025T030000\r\n';
          icsMSG += 'RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r\n';
          icsMSG += 'END:STANDARD\r\n';
          icsMSG += 'END:VTIMEZONE\r\n'; 
          icsMSG += icsDates;
          icsMSG += 'END:VCALENDAR\r\n';

          var title = btn.dataset.title + ".ics";
          const blob = new Blob([icsMSG], { type: 'text/calendar' });
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url
          link.download = title;
          link.target = '_blank'
          link.click();

          URL.revokeObjectURL(url);
        })
      })
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }

  gameDragons() {
    const dragon = document.querySelector('.dragon');
    const counter = document.querySelector('.game-dragon--counter');
    const popinStart = document.querySelector('.popin-start');
    const popinHelp = document.querySelector('.popin-help');
    const popinEnd = document.querySelector('.popin-end');
    let dragons = Cookies.get('dragons');

    /** Click on the dragon */
    if( dragon ) {
      const img = dragon.querySelector('img');
      img.addEventListener('mouseenter', () => {
        dragon.classList.add('hover')
      })
      img.addEventListener('mouseleave', () => {
        dragon.classList.remove('hover')
      })
      img.addEventListener('click', e => {
        e.preventDefault();

        if( dragons == undefined ) dragons = [];
        else if ( typeof dragons != 'object' ) dragons = dragons.split(',');

        dragons.push(dragon.dataset.id);
        dragon.classList.add('clicked')

        Cookies.set('dragons', dragons.join(','));

        // Show the counter 
        if( counter ) counter.classList.add('show')
        window.dispatchEvent(new Event('update-counter'));
      })

      window.addEventListener('scroll', () => {
        if(window.scrollY >= window.innerHeight * 0.3 ) {
          dragon.classList.add('start');
        }
      })
    }

    /** Popins */
    const closes = document.querySelectorAll('.popin-game .trigger-close');
    if( closes ) {
      closes.forEach(close => {
        close.addEventListener('click', e => {
          e.preventDefault();
          const parent = close.closest('.popin-game');
          if( parent ) {
            parent.classList.remove('show');
            HTML.classList.remove('open-popin')
          }
        })
      })
    }

    /** Popin help */
    if( popinHelp && counter ) {
      const trigger = counter.querySelector('.trigger-help');
      if( trigger ) {
        trigger.addEventListener('click', e => {
          e.preventDefault();
          const els = document.querySelectorAll('.popin-game.show');          
          if( els ) els.forEach(el => el.classList.remove('show'))

          popinHelp.classList.add('show');
          HTML.classList.add('open-popin')
        })
      }
    }

    /** Update counter */
    if( counter ) {
      const total = parseInt(counter.dataset.total);

      // Send to form
      counter.addEventListener('click', e => {
        if( dragons.length >= total ) {
          e.preventDefault();

          window.location.href = counter.dataset.url
        }

      })

      window.addEventListener('update-counter', () => {
        if( dragons == undefined ) dragons = [];
        else if ( typeof dragons != 'object' )  dragons.split(',');

        counter.querySelector('.current').innerHTML = (dragons.length > 9 ? '' : '0') + dragons.length;

        if( dragons.length == 1 ) {
          popinStart.classList.add('show');
          HTML.classList.add('open-popin');
        }
        else if( dragons.length >= total ) {
          counter.classList.add('show-end')
          popinEnd.classList.add('show');
          HTML.classList.add('open-popin');
        }
        else if( dragons.length >= Math.round(total / 2) ) {
          counter.classList.add('show-help')
        }
      })
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
